<template>
  <div class="files">
    <Form :label-width="70">
      <Row :gutter="32">
        <Col :md="18">
          <FormItem label="文件名称">
            <Input v-model="searchQuery.filetitle" />
          </FormItem>
        </Col>
        <Col :md="3" class-name="inquireBtn">
          <Button
            class="submitBtn"
            type="primary"
            @click="handleSubmit"
          >查询</Button>
        </Col>
      </Row>
    </Form>
    <Table
      border
      stripe
      :columns="columns"
      :data="data"
      :loading="loading"
      :max-height="520"
    />
    <Page
      v-if="total > pageSize"
      :total="total"
      show-sizer
      show-elevator
      :page-size="pageSize"
      :current="current"
      @on-change="handleChange"
      @on-page-size-change="handlePageSizeChange"
      style="margin-top: 8px"
    />
  </div>
</template>

<script>
import { GetFilesPaging, GetFiles } from '@api'
export default {
  name: 'search-filesTable',
  props: {
    selection: {
      type: Array,
      default: () => []
    },
    engSid: {
      type: String
    }
  },
  data () {
    return {
      searchQuery: {},
      columns: [],
      loading: false,
      data: [],
      item: {},
      total: 0,
      pageSize: 10,
      current: 1
    }
  },
  mounted () {
    this.buildColumns()
  },
  methods: {
    async init (row = {}) {
      this.item = row
      this.data = []
      if (!row.SID) return
      await this.getArchPage()
    },
    buildColumns () {
      const columns = [
        {
          title: '文件题名',
          key: 'FILE_TITLE'
        }, {
          title: '页次',
          width: 100,
          align: 'center',
          key: 'PAGE_NO'
        }, {
          title: '操作',
          width: 150,
          align: 'center',
          render: (h, params) => {
            return (
              <div class="btnGroup">
                <Button
                  type="info"
                  size="small"
                  disabled={ this.selection.some(s => s.SID === params.row.SID) }
                  onClick={ () => this.$emit('on-select', params.row) }
                >申请</Button>
                <Button
                  type="info"
                  size="small"
                  onClick={ () => this.$emit('on-select-cancel', params.row) }
                >取消</Button>
              </div>
            )
          }
        }
      ]
      this.$set(this, 'columns', columns)
    },
    handleSubmit () {
      this.current = 1
      this.getPage()
    },
    async getPage () {
      if (!this.engSid) {
        this.$Message.warning('请先选择一个工程')
        return
      }
      this.loading = true
      try {
        const query = Object.assign({
          pageindex: this.current,
          pagesize: this.pageSize,
          engsid: this.engSid
        }, this.searchQuery)
        const { data: { list, total } } = await GetFilesPaging(query)
        this.data = list || []
        this.total = total
      } catch (e) {
        console.error(e)
      }
      this.loading = false
    },
    async getArchPage () {
      this.loading = true
      this.total = 0
      try { 
        const query = { SID: this.item.SID }
        const { data: { list, total } } = await GetFiles(query)
        this.data = list || []
      } catch (e) {
        console.error(e)
      }
      this.loading = false
    },
    handleChange (index) {
      this.current = index
      this.getPage()
    },
    handlePageSizeChange (size) {
      this.pageSize = size
      this.getPage()
    }
  }
}
</script>

<style lang="scss" scoped>
.files {
  width: 100%;
  height: 100%;
}
.ivu-table-wrapper {
  margin-top: 16px;
}
</style>
